import { c as _c } from "react/compiler-runtime";
import { Modal, ModalSizeEnum, PrimaryButton, RadioGroup, RadioGroupDataInterface } from '@systemeio/ui';
import React, { useState, useEffect } from 'react';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { WebsiteSourceEnum, websiteSourceLocoKeys } from '../enum/website-type-enum';
import { useWebsiteTemplatesListAll, WebsiteTemplateInterface } from '../hooks/use-website-templates-list-all';
import { Loader } from 'shared/components/loader';
import { useWebsiteActions } from '../hooks/use-website-actions';
import ScrollImage from 'shared/components/scroll-image';
import { TemplateCard } from 'shared/components/template-card';
const SCRATCH_TEMPLATE_ID = 1;
interface WebsiteTemplateModalProps {
  websiteId: number;
  opened: boolean;
  onClose: () => void;
  afterLeave?: () => void;
}
export const WebsiteTemplateModal = t0 => {
  const $ = _c(50);
  const {
    websiteId,
    opened,
    onClose,
    afterLeave
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const [selectedSource, setSelectedSource] = useState(WebsiteSourceEnum.ChooseTemplate);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const {
    websitesTemplate,
    isLoading
  } = useWebsiteTemplatesListAll(opened);
  const {
    chooseWebsiteTemplate,
    postIsFetching
  } = useWebsiteActions();
  let t1;
  if ($[0] !== t) {
    t1 = t(websiteSourceLocoKeys[WebsiteSourceEnum.ChooseTemplate]);
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = {
      id: WebsiteSourceEnum.ChooseTemplate,
      caption: t1
    };
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t) {
    t3 = t(websiteSourceLocoKeys[WebsiteSourceEnum.StartFromScratch]);
    $[4] = t;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t3) {
    t4 = {
      id: WebsiteSourceEnum.StartFromScratch,
      caption: t3
    };
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t2 || $[9] !== t4) {
    t5 = [t2, t4];
    $[8] = t2;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const websiteSourceData = t5;
  let t6;
  if ($[11] !== chooseWebsiteTemplate || $[12] !== onClose || $[13] !== selectedSource || $[14] !== selectedTemplate || $[15] !== websiteId) {
    t6 = async () => {
      if (selectedSource === WebsiteSourceEnum.ChooseTemplate && selectedTemplate) {
        await chooseWebsiteTemplate(websiteId, selectedTemplate);
      } else {
        await chooseWebsiteTemplate(websiteId, SCRATCH_TEMPLATE_ID);
      }
      onClose();
    };
    $[11] = chooseWebsiteTemplate;
    $[12] = onClose;
    $[13] = selectedSource;
    $[14] = selectedTemplate;
    $[15] = websiteId;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  const handleSave = t6;
  let t7;
  if ($[17] !== afterLeave) {
    t7 = () => {
      setSelectedTemplate(null);
      setSelectedSource(WebsiteSourceEnum.ChooseTemplate);
      if (afterLeave) {
        afterLeave();
      }
    };
    $[17] = afterLeave;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  const onAfterLeave = t7;
  let t8;
  let t9;
  if ($[19] !== selectedTemplate || $[20] !== websitesTemplate) {
    t8 = () => {
      if (websitesTemplate && websitesTemplate.length !== 0 && !selectedTemplate) {
        setSelectedTemplate(websitesTemplate[0]?.id ?? null);
      }
    };
    t9 = [websitesTemplate, selectedTemplate];
    $[19] = selectedTemplate;
    $[20] = websitesTemplate;
    $[21] = t8;
    $[22] = t9;
  } else {
    t8 = $[21];
    t9 = $[22];
  }
  useEffect(t8, t9);
  const t10 = isLoading || postIsFetching;
  let t11;
  if ($[23] !== t) {
    t11 = t("dashboard.website.template_modal_title");
    $[23] = t;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== isLoading || $[26] !== postIsFetching || $[27] !== selectedSource || $[28] !== selectedTemplate || $[29] !== t || $[30] !== websiteSourceData || $[31] !== websitesTemplate) {
    t12 = isLoading ? <div className="flex h-full items-center justify-center"><Loader type="dark" /></div> : <><span>{t("dashboard.website.template_modal_subtitle")}</span><RadioGroup selected={selectedSource} options={websiteSourceData} onChange={setSelectedSource} disabled={postIsFetching} />{selectedSource === WebsiteSourceEnum.ChooseTemplate && websitesTemplate && <TemplateGrid templates={websitesTemplate} selectedTemplate={selectedTemplate} onSelect={setSelectedTemplate} />}</>;
    $[25] = isLoading;
    $[26] = postIsFetching;
    $[27] = selectedSource;
    $[28] = selectedTemplate;
    $[29] = t;
    $[30] = websiteSourceData;
    $[31] = websitesTemplate;
    $[32] = t12;
  } else {
    t12 = $[32];
  }
  let t13;
  if ($[33] !== t) {
    t13 = t("global.save");
    $[33] = t;
    $[34] = t13;
  } else {
    t13 = $[34];
  }
  let t14;
  if ($[35] !== handleSave || $[36] !== isLoading || $[37] !== postIsFetching || $[38] !== t13) {
    t14 = <div className="flex justify-center"><PrimaryButton width="large" onClick={handleSave} disabled={isLoading} isFetching={postIsFetching}>{t13}</PrimaryButton></div>;
    $[35] = handleSave;
    $[36] = isLoading;
    $[37] = postIsFetching;
    $[38] = t13;
    $[39] = t14;
  } else {
    t14 = $[39];
  }
  let t15;
  if ($[40] !== t12 || $[41] !== t14) {
    t15 = <div className="flex flex-col gap-4 lg:gap-6">{t12}{t14}</div>;
    $[40] = t12;
    $[41] = t14;
    $[42] = t15;
  } else {
    t15 = $[42];
  }
  let t16;
  if ($[43] !== onAfterLeave || $[44] !== onClose || $[45] !== opened || $[46] !== t10 || $[47] !== t11 || $[48] !== t15) {
    t16 = <Modal isFetching={t10} opened={opened} onClose={onClose} afterLeave={onAfterLeave} title={t11} size={ModalSizeEnum.medium} closeIconWrapperClassName="hidden">{t15}</Modal>;
    $[43] = onAfterLeave;
    $[44] = onClose;
    $[45] = opened;
    $[46] = t10;
    $[47] = t11;
    $[48] = t15;
    $[49] = t16;
  } else {
    t16 = $[49];
  }
  return t16;
};
const TemplateGrid = t0 => {
  const $ = _c(9);
  const {
    templates,
    selectedTemplate,
    onSelect
  } = t0;
  let t1;
  if ($[0] !== onSelect || $[1] !== selectedTemplate || $[2] !== templates) {
    let t2;
    if ($[4] !== onSelect || $[5] !== selectedTemplate) {
      t2 = item => <TemplateCard className="h-44 w-64" isActive={selectedTemplate === item.id} key={item.id} onSelect={() => onSelect(selectedTemplate === item.id ? null : item.id)}><ScrollImage src={item.previewUrl} /></TemplateCard>;
      $[4] = onSelect;
      $[5] = selectedTemplate;
      $[6] = t2;
    } else {
      t2 = $[6];
    }
    t1 = templates.map(t2);
    $[0] = onSelect;
    $[1] = selectedTemplate;
    $[2] = templates;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[7] !== t1) {
    t2 = <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">{t1}</div>;
    $[7] = t1;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return t2;
};